import firebase from 'firebase/compat/app';
import {doc, setDoc, getDoc} from "firebase/firestore";
import {firestore} from "../../firebase";
import {v4 as uuidv4} from 'uuid';
import {SubmitBusinessParams} from "./firestore.types";
import {businessFromJson} from "../../models/business/business";

export class BusinessFirestore {

    async submitBusiness(formData: SubmitBusinessParams) {
        try {
            const uuid = uuidv4();
            const millis = Date.now();
            const id = `${uuid}-${millis}`

            await setDoc(doc(firestore, "business",id), {
                ...formData,
                id,
                status: "Submitted",
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
                updatedAt: firebase.firestore.FieldValue.serverTimestamp()
            })

            return { kind: "ok" }

        } catch (e) {
            return { kind: "bad-data" }
        }
    }

    async getBusiness(id: string) {
        try {
            const snapshot = await getDoc(doc(firestore, "business",id))

            return { kind: "ok", data: businessFromJson(snapshot.data()) }

        } catch (e) {
            return { kind: "bad-data" }
        }
    }
}
